Notices =
{
	init : function()
	{
		// Make wrapper elements the same height.
		//jQuery('.notice-board-list .wrapper').matchHeight({
		//    byRow: true,
		//    property: 'height',
		//    target: null,
		//    remove: false
		//});
	}
};//end object literal Notices

jQuery(document).ready(function(jQuery){
	
	Notices.init();
		
});
